import { motion } from 'framer-motion';

const FeaturesSection = () => {
  const features = [
    {
      icon: 'ri-heart-pulse-line',
      title: '経験豊富なスタッフ',
      description: '介護福祉士・ヘルパー2級以上の資格を持つ経験豊富なスタッフが、心を込めてサポートいたします。',
    },
    {
      icon: 'ri-time-line',
      title: '24時間365日対応可能',
      description: '緊急時や夜間・早朝のご依頼にも柔軟に対応。いつでも安心してご相談いただけます。',
    },
    {
      icon: 'ri-map-pin-line',
      title: '岡山市北区地域密着',
      description: '地域に根ざしたサービスで、岡山市北区の皆様の暮らしを長年サポートしてまいりました。',
    },
    {
      icon: 'ri-user-heart-line',
      title: '一人ひとりに寄り添う',
      description: 'お客様のご要望やライフスタイルに合わせた、オーダーメイドのケアプランをご提案します。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '安心の保険適用',
      description: '介護保険を利用した訪問介護サービスで、経済的な負担を抑えながら質の高いケアを受けられます。',
    },
    {
      icon: 'ri-chat-smile-3-line',
      title: '丁寧なコミュニケーション',
      description: 'ご本人様・ご家族様との対話を大切にし、信頼関係を築きながらサポートいたします。',
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 sm:mb-16"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-800 mb-4 px-4">
            ヘルパーステーションおかやまが選ばれる理由
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-navy-700 max-w-2xl mx-auto px-4">
            岡山市北区で安心の訪問介護サービスを提供し続けています
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-beige-50 rounded-2xl p-6 sm:p-8 hover:shadow-lg transition-shadow"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-coral-500 rounded-full mb-5">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-navy-800 mb-4 leading-tight">
                {feature.title}
              </h3>
              <p className="text-sm sm:text-base text-navy-700 leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
